import { useCallback } from "react";

import { useFormContext } from "react-hook-form";

import { useRateContext } from "../Context/RateContext";

import { trpc } from "@/common/helpers/trpc";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useEnableMemberOnly = () => {
  const { rateIndex } = useRateContext();
  const { setValue } = useFormContext<StepTicketsFormData>();

  const { data: hasMemberships } = trpc.hasMemberships.useQuery({ onlyConsiderActiveStatus: true });
  const { data: membershipRates } = trpc.getMembershipTypes.useQuery({}, { enabled: Boolean(hasMemberships) });

  const applyMembershipSelection = useCallback(
    (checked: boolean) => {
      if (checked) {
        if (!membershipRates) {
          return;
        }
        setValue(
          `rates.${rateIndex}.memberOnlyMembershipRateIds`,
          membershipRates.map((m) => m.rateId),
          { shouldDirty: true }
        );
      } else {
        setValue(`rates.${rateIndex}.memberOnlyMembershipRateIds`, [], { shouldDirty: true });
      }
    },
    [rateIndex, membershipRates, setValue]
  );

  const enableMemberOnly = useCallback(() => {
    setValue(`rates.${rateIndex}.isMemberOnly`, true, { shouldDirty: true });
    applyMembershipSelection(true);
  }, [rateIndex, setValue, applyMembershipSelection]);

  return {
    hasMemberships: Boolean(hasMemberships),
    canEnableMemberOnly: Boolean(hasMemberships) && membershipRates !== undefined,
    applyMembershipSelection,
    enableMemberOnly,
  };
};
